import { makeStyles } from '@mui/styles';
import { body2, caption } from '../../../shared/theme/text.styles';

export const useJobCardStyles = makeStyles((theme) => ({
  root: {
    width: '448px',
    minWidth: '448px',
    maxWidth: '100%',
    height: '400px',
    backdropFilter: 'blur(10px)',
    borderRadius: '5px',

    [theme.breakpoints.down('md')]: {
      width: '300px',
      minWidth: '300px',
      height: '280px',
    },
  },

  imgWrapper: {
    height: 180,

    [theme.breakpoints.down('md')]: {
      height: '120px',
    },
  },

  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'center',
  },

  jobTitle: {
    textTransform: 'capitalize',
    marginTop: '16px !important',
    marginBottom: '8px !important',
    ...caption,
  },

  location: {
    textTransform: 'capitalize',
    marginBottom: '30px !important',
    ...body2,
  },
}));
